import { Backend } from '@/_axios';

export default {
  list(projectId, params) {
    return Backend.get(`/project/${projectId}/project_users/`, { params });
  },
  createData(projectId) {
    return Backend.get(`/project/${projectId}/project_users/create`);
  },
  editData(projectId, id) {
    return Backend.get(`/project/${projectId}/project_users/${id}/edit`);
  },
  create(projectId, data) {
    return Backend.post(`/project/${projectId}/project_users/`, data);
  },
  update(projectId, data) {
    return Backend.put(`/project/${projectId}/project_users/${data.id}`, data);
  },
  delete(projectId, id) {
    return Backend.delete(`/project/${projectId}/project_users/${id}`);
  },
};
